export default abstract class BaseModel {
  abstract toString(): string;
  abstract toJSON(): any;
}
